module.exports = __webpack_public_path__ + "img/pilares_grey.f9a58027.png";